import { ReactElement, useContext } from "react"

import {
    IPossibleRecognisedFormSpecs,
    isAttachmentRecognisedForm,
    isSelectDeviceRecognisedForm,
} from "../../../../../services/middleware/types/singleApplication/getSchemaTypes"
import { isIUploadArray } from "../../../../../services/middleware/types/singleApplication/uploadAttachmentTypes"
import { ApplicationContext } from "../../applicationProvider"
import InputNotFound from "../../inputGenerator/inputNotFound"
import AttachmentArray from "../../recognisedForms/attachmentArray"
import {
    ATTACHMENT_INPUT_01_IMAGES,
    RECOGNISED_INPUT_ID_KW,
    SELECT_DEVICE_RECOGNISED_FORM_01,
} from "../../recognisedForms/recongisedFormKeys"
import SelectDeviceForm from "../../recognisedForms/selectDeviceForm"

export const MAX_CUT_OUT_IMAGES_PER_APPLICATION = 1

interface IRecognisedFormGeneratorProps {
    formKey: string
    formProperties: IPossibleRecognisedFormSpecs
}

/**
 * Generates pre-recognised forms. These forms are not dynamically generated,
 * but are instead pre-defined, and agreed upon by the API and the frontend.
 */
const RecognisedFormGenerator = ({
    formKey,
    formProperties,
}: IRecognisedFormGeneratorProps): ReactElement => {
    const { supplementingInfo } = useContext(ApplicationContext)
    const inputSupplementingInfo = supplementingInfo?.[formKey]

    if (isAttachmentRecognisedForm(formProperties)) {
        return (
            <AttachmentArray
                imageMode={
                    formProperties[RECOGNISED_INPUT_ID_KW] ===
                    ATTACHMENT_INPUT_01_IMAGES
                }
                formKey={formKey}
                minItems={formProperties.minItems}
                maxItems={formProperties.maxItems}
                fileUrlKey={Object.keys(formProperties.items.properties)[0]}
                initialUploads={
                    isIUploadArray(inputSupplementingInfo)
                        ? inputSupplementingInfo
                        : []
                }
            />
        )
    }
    if (isSelectDeviceRecognisedForm(formProperties)) {
        return (
            <SelectDeviceForm
                formKey={formKey}
                formProperties={formProperties}
                isNewDeviceMode={
                    formProperties[RECOGNISED_INPUT_ID_KW] ===
                    SELECT_DEVICE_RECOGNISED_FORM_01
                }
            />
        )
    }
    return <InputNotFound inputName={formKey} />
}

export default RecognisedFormGenerator
